import dayjs from 'mixins/dayjsConfig';
import {
    HOME_BANNER_DATE_FORMAT,
    HOME_BANNER_DATE_TIME_FORMAT,
} from '../home-banners/constants';
import { HomeBanner, HomeBannerFormValues } from './types';

export const HOME_BANNER_FORM_INITIAL_VALUES: HomeBannerFormValues = {
    enabled: true,
    titleRu: '',
    titleKk: '',
    descriptionRu: '',
    descriptionKk: '',
    linkUrl: '',
    imageId: '',
    publishStartDate: '',
    publishEndDate: '',
    displayOrder: 1,
};

export const formatDateLabel = (date?: string) =>
    date ? dayjs(date).format(HOME_BANNER_DATE_FORMAT) : 'без ограничения';

export const formatDateTimeLabel = (date?: string | number) =>
    date ? dayjs(date).format(HOME_BANNER_DATE_TIME_FORMAT) : '';

export const isBannerActive = (banner: HomeBanner): boolean => {
    const today = dayjs().startOf('day');

    return (
        banner.enabled &&
        (!banner.publishStartDate || !dayjs(banner.publishStartDate).isAfter(today)) &&
        (!banner.publishEndDate || !dayjs(banner.publishEndDate).isBefore(today))
    );
};

export const toFormValues = (banner: HomeBanner): HomeBannerFormValues => ({
    enabled: banner.enabled,
    titleRu: banner.titleRu,
    titleKk: banner.titleKk,
    descriptionRu: banner.descriptionRu,
    descriptionKk: banner.descriptionKk,
    imageId: banner.imageId,
    linkUrl: banner.linkUrl,
    publishStartDate: banner.publishStartDate,
    publishEndDate: banner.publishEndDate,
    displayOrder: banner.displayOrder,
});

export const toPayload = (values: HomeBannerFormValues): HomeBannerFormValues => ({
    ...values,
    displayOrder: Number(values.displayOrder || 0),
});

export const getNextDisplayOrder = (items: HomeBanner[]) =>
    items.reduce((max, item) => Math.max(max, Number(item.displayOrder || 0)), 0) + 1;

export const getOrderOptions = (count: number) =>
    Array.from({ length: Math.max(count, 1) }, (_, index) => index + 1);
